module.exports = __webpack_public_path__ + "img/delizia-min.af754c7b.jpg";